module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "处理投诉"
    },
    model: {
      value: (_vm.visibleThis),
      callback: function($$v) {
        _vm.visibleThis = $$v
      },
      expression: "visibleThis"
    }
  }, [_c('Form', {
    ref: "editSalaryForm",
    staticClass: "form",
    attrs: {
      "label-width": 80,
      "complaintRow": _vm.complaintRowThis,
      "model": _vm.complaintRowThis,
      "rules": _vm.ruleSalary
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Row', [_c('Form-item', {
    attrs: {
      "label": "投诉理由",
      "prop": "remark"
    }
  }, [_c('Select', {
    attrs: {
      "disabled": ""
    },
    on: {
      "on-change": _vm.changeRemark
    },
    model: {
      value: (_vm.complaintRowThis.remark),
      callback: function($$v) {
        _vm.$set(_vm.complaintRowThis, "remark", $$v)
      },
      expression: "complaintRowThis.remark"
    }
  }, _vm._l((_vm.$constant.tchComplaintRemark), function(item, index) {
    return _c('Option', {
      key: index,
      attrs: {
        "value": item.text
      }
    }, [_vm._v(_vm._s(item.text) + "\n              ")])
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Row', [_c('Form-item', {
    attrs: {
      "label": "学生赠送课时",
      "prop": "stdNum"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.complaintRowThis.stdNum),
      callback: function($$v) {
        _vm.$set(_vm.complaintRowThis, "stdNum", $$v)
      },
      expression: "complaintRowThis.stdNum"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Row', [_c('Form-item', {
    attrs: {
      "label": "老师课耗",
      "prop": "subSalary"
    }
  }, [_c('Select', {
    model: {
      value: (_vm.complaintRowThis.subSalary),
      callback: function($$v) {
        _vm.$set(_vm.complaintRowThis, "subSalary", $$v)
      },
      expression: "complaintRowThis.subSalary"
    }
  }, _vm._l((this.subSalaryEnum), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Row', [_c('Form-item', {
    attrs: {
      "label": "老师额外扣除($)",
      "prop": "tchNum"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.complaintRowThis.tchNum),
      callback: function($$v) {
        _vm.$set(_vm.complaintRowThis, "tchNum", $$v)
      },
      expression: "complaintRowThis.tchNum"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Row', [_c('Form-item', {
    attrs: {
      "label": "处理意见",
      "prop": "doRemark"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入处理意见:警告"
    },
    model: {
      value: (_vm.complaintRowThis.doRemark),
      callback: function($$v) {
        _vm.$set(_vm.complaintRowThis, "doRemark", $$v)
      },
      expression: "complaintRowThis.doRemark"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visibleThis = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingEditSalary
    },
    on: {
      "click": _vm.editSalary
    }
  }, [_vm._v("\n      保存\n    ")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4b437b4e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/teacher/modal/ModifyComplaintModal.vue
// module id = 1801
// module chunks = 8